import { TakeDefined } from '@types';
import { FlexPoolsTableColumnDefinition } from './flex-pools-table.types';
import { useGetInternalFlexPools } from '../../../../hooks/use-get-internal-flex-pools';

export const getFlexPoolsTableData = (
  data: TakeDefined<ReturnType<typeof useGetInternalFlexPools>['data']>
) => {
  const result: FlexPoolsTableColumnDefinition[] = data.items.map((item) => {
    return {
      id: item.id,
      flexPoolName: item.name,
      departmentNames: item.departmentNames,
      flexWorkerCount: item.flexWorkerCount,
    };
  });
  return result;
};
